import { Navigate, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/owner", end: true, label: "Overview", icon: "📊", testid: "owner-tab-dashboard" },
  { to: "/owner/users", label: "Customers", icon: "👥", testid: "owner-tab-users" },
  { to: "/owner/messages", label: "Messages", icon: "💬", testid: "owner-tab-messages" },
  { to: "/owner/stock-requests", label: "Stock requests", icon: "🛒", testid: "owner-tab-stock-requests" },
  { to: "/owner/product-library", label: "Library", icon: "📚", testid: "owner-tab-product-library" },
  { to: "/owner/plans", label: "Plans & pricing", icon: "💷", testid: "owner-tab-plans" },
  { to: "/owner/coupons", label: "Coupons", icon: "🎟️", testid: "owner-tab-coupons" },
  { to: "/owner/account", label: "Account", icon: "🌿", testid: "owner-tab-account" },
];

export default function OwnerLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-[#5C6B61]">Loading…</div>;
  }
  if (!user) return <Navigate to="/owner/login" replace />;
  if (!user.is_admin) return <Navigate to="/app" replace />;

  return (
    <div className="min-h-screen bg-[#FAF9F6] text-[#2A332C]" style={{ fontFamily: "Inter, sans-serif" }}>
      {/* Top bar */}
      <header className="border-b border-[#E5E2DA] bg-white sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-2.5">
            <span className="w-8 h-8 rounded-full bg-[#2A332C] flex items-center justify-center text-white text-sm">🛡️</span>
            <div>
              <div className="text-base font-medium leading-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
                Shop, Cal & Meal · Owner
              </div>
              <div className="text-[11px] text-[#8B9690] leading-tight">{user.email}</div>
            </div>
          </div>
          <button
            onClick={async () => { await logout(); navigate("/owner/login"); }}
            data-testid="owner-signout-btn"
            className="text-xs font-medium text-[#5C6B61] hover:text-[#A33D26] transition px-3 py-1.5 rounded-full hover:bg-[#FBE5DE]"
          >
            Sign out
          </button>
        </div>
      </header>

      {/* Sidebar + main */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 grid md:grid-cols-[220px_minmax(0,1fr)] gap-6">
        <aside className="md:sticky md:top-20 md:self-start">
          {/* Mobile: horizontal scroll. Desktop: vertical stack. */}
          <nav
            className="flex md:flex-col gap-1 overflow-x-auto md:overflow-visible -mx-4 px-4 md:mx-0 md:px-0 pb-2 md:pb-0"
            data-testid="owner-sidebar"
          >
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={item.testid}
                className={({ isActive }) =>
                  `flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium whitespace-nowrap transition flex-none md:flex-auto ${
                    isActive
                      ? "bg-[#2A332C] text-white"
                      : "text-[#5C6B61] hover:bg-[#F3F0EA] hover:text-[#2A332C]"
                  }`
                }
              >
                <span className="text-lg">{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </aside>
        <main className="min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
